import Api from "./baseApi";

export default {
  getList: (q, categoryId) => {
    let url = "/api/mpproducts/dispatch-time?v=1";
    if (q) url += `&q=${encodeURIComponent(q)}`;
    if (categoryId != null && categoryId > 0) url += `&categoryId=${categoryId}`;
    return Api.get(url);
  },
  bulkUpdate: body =>
    Api.post("/api/mpproducts/dispatch-time/update", body)
};
